export const AUTH_ROUTES = [
  '/login',
  '/register',
  '/forgot-password',
  '/password-reset'
] as const;
